<div class="container-fluid" style="overflow-y: auto;">
	<div class="row">
		<div class="col-md-12">
			<h1>
				<span jhiTranslate="multi-trait-query.title">MULTI-TRAIT QUERY</span>&nbsp;
                <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
			</h1>
		</div>
	</div>
	<br>
	<div class="row">
		<div class="col-md-12">
			<div class="card panel-default">
				<div class="card-body">
					<mat-accordion [multi]="false" displayMode="flat">
						<mat-expansion-panel (opened)="setStep(0)" [expanded]="step() === 0" hideToggle>
							<mat-expansion-panel-header>
								<mat-panel-title><span jhiTranslate="multi-trait-query.panel.introduction.title"></span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<jhi-step-introduction (next)="nextStep()" [active]="step() === 0"></jhi-step-introduction>
						</mat-expansion-panel>
						<mat-expansion-panel (opened)="setStep(1)" [disabled]="step() > 2" [expanded]="step() === 1" hideToggle>
							<mat-expansion-panel-header>
								<mat-panel-title><span jhiTranslate="multi-trait-query.panel.select.traits.title"></span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<jhi-step-select-traits (next)="nextStep()" [active]="step() === 1"></jhi-step-select-traits>
						</mat-expansion-panel>
						<mat-expansion-panel (opened)="setStep(2)" [disabled]="!isStepEnabled(2)" [expanded]="step() === 2" hideToggle>
							<mat-expansion-panel-header>
								<mat-panel-title><span jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.title"></span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<jhi-step-specify-and-weight-the-environments (back)="prevStep()" (next)="nextStep()" [active]="step() === 2">
							</jhi-step-specify-and-weight-the-environments>
						</mat-expansion-panel>
						<mat-expansion-panel (opened)="setStep(3)" [disabled]="!isStepEnabled(3)" [expanded]="step() === 3" hideToggle>
							<mat-expansion-panel-header>
								<mat-panel-title><span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.title"></span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<ng-container *ngIf="step() === 3">
								<jhi-step-setup-the-trait-filter (back)="prevStep()" (next)="nextStep()" [active]="step() === 3"></jhi-step-setup-the-trait-filter>
							</ng-container>
						</mat-expansion-panel>
						<mat-expansion-panel (opened)="setStep(4)" [disabled]="!isStepEnabled(4)" [expanded]="step() === 4" hideToggle>
							<mat-expansion-panel-header>
								<mat-panel-title><span jhiTranslate="multi-trait-query.panel.display.result.title"></span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<ng-container *ngIf="step() === 4">
								<jhi-step-display-results (backToBeginning)="setStep(0)" (backToStepEnv)="setStep(2)" [active]="step() === 4"></jhi-step-display-results>
							</ng-container>
						</mat-expansion-panel>
					</mat-accordion>
				</div>
			</div>
		</div>
	</div>
	<div class="container-fluid">
		<router-outlet name="popup"></router-outlet>
	</div>
</div>
